import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../../../../context/AuthContext";
import PropTypes from "prop-types";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { LogoFVC, PrinterIcon } from "../../../../data/iconImage";
import { useLoading } from "../../../../context/LoadingContext";
import { FloatingControlComponent, FormCheckComponent } from "../../../../components/FormComponent";
import PaginationComponent from "../../../../components/PaginationComponent";
import {
  autoDisplayValue,
  formatDate,
  formatSplitKey,
  formatTime
} from "../../../../commons/FormatValue";
import Table from "../../../../components/Table";

import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import TechnicianPlansService from "../../../../services/technicianplan.service";
import {
  filteredItemInArray,
  findItemInArray
} from "../../../../utils/ManageArray";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import PrintButton from "../../../../components/PrintButton";
import ReportHeadComponent from "../../../../components/ReportHeadComponent";
import { formatDateTime } from "../../../../commons/FormatValue";
import CustContractItemsService from "../../../../services/custcontractitem.service";

const PreviewOther = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [currentPage, setCurrentPage] = useState(1);
  const [CustContractItems, setCustContractItems] = useState([]);
  const Seq = {
    ...state,
    Printed_By: user?.username,
    Printed_Date_Time: formatDateTime(new Date().toISOString()),
    Approver: ""
  };
  console.log(state)
  const inputField = {
    headerReport: [
      {
        name: "SeqOthersJob.Seq_Oth_No",
        label: "หมายเลขใบสั่งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      },
      {
        name: "createdAt",
        label: "วันที่ออกใบสั่งงาน",
        size: 6,
        format: (row) => formatDate(row)
      },
      {
        name: "createdAt",
        label: "เวลา",
        size: 6,
        format: (row) => formatTime(row)
      }
    ],
    Inform: [
      {
        name: "SeqOthersJob.InformOtherJob.Customer.Cus_Code",
        label: "รหัสลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Customer.Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "SeqOthersJob.InformOtherJob.Ref_Doc_No",
        label: "อ้างอิงหมายเลขแจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.BPCustomer.Cus_Code",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "SeqOthersJob.InformOtherJob.BPCustomer.Cus_NumBrach",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "SeqOthersJob.InformOtherJob.BPCustomer.Cus_Name",
        label: "ชื่อสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "SeqOthersJob.InformOtherJob.Inform_Doc_Date",
        label: "วันที่แจ้งงาน",
        size: "1_5",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
      {
        name: "SeqOthersJob.InformOtherJob.Inform_Doc_Date",
        label: "เวลา",
        size: "1_5",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatTime(row)
      },
      {
        name: "SeqOthersJob.InformOtherJob.Customer.Cus_Address",
        label: "ที่อยู่",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9,
        as: "textarea",
        plusString: `${Seq?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Address || ""} ${Seq?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Road || ""
          } ${Seq?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_District || ""} ${Seq?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_SubDistrict || ""
          } ${Seq?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Province || ""} ${Seq?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_ZipCode || ""
          }`
      },
      {
        name: "SeqOthersJob.InformOtherJob.Job_Cus_Date",
        label: "วันที่นัดหมายลูกค้า",
        size: "1_5",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
      {
        name: "SeqOthersJob.InformOtherJob.Job_Cus_Date",
        label: "เวลา",
        size: "1_5",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatTime(row)
      },
      {
        name: "SeqOthersJob.InformOtherJob.Cus_Contract_Tel1",
        label: "เบอร์โทรผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Cus_Contract_Name1",
        label: "ผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "SeqOthersJob.InformOtherJob.Project_No",
        label: "เลขที่โครงการ",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Cus_Contract_Tel2",
        label: "เบอร์โทรผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Cus_Contract_Name2",
        label: "ผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "SeqOthersJob.InformOtherJob.Service_Call",
        label: "Call No.",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Cus_Cpec_Tex",
        label: "คำสั่งเพิ่มเติม (ลูกค้า)",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      },
      { name: "SeqOthersJob.InformOtherJob.JobType.Job_Type_Name", label: "ประเภทงาน" },
      {
        name: "SeqOthersJob.InformOtherJob.JobTypeSub.Job_Type_Sub_Name",
        label: "ประเภทงานย่อย",
        size: 6
      },
      { name: "SequneceStatus.Seq_St_Name", label: "สถานะ" }
    ],
    Inform2: [
      {
        name: "SeqOthersJob.InformOtherJob.Job_Name",
        label: "ชื่องาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "SeqOthersJob.InformOtherJob.To_Section",
        label: "ถึงแผนก",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Sub_Team",
        label: "ชื่อทีม/หัวหน้าช่าง",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "SeqOthersJob.InformOtherJob.Subject_Inform",
        label: "เรื่องที่แจ้ง",
        size: 6
      },
      { name: "SeqOthersJob.InformOtherJob.Remark", label: "หมายเหตุ", size: 6 }
    ],
    PreventiveRadio: [
      { name: "PM_List", label: "มี PM" },
      { name: "PM_List", label: "ไม่มี PM" },
      { name: "PM_List", label: "รอสรุป" }
    ],
    PreventiveInput: [
      {
        name: "SeqOthersJob.InformOtherJob.CustContract.Contract_No",
        label: "เลขที่สัญญา",
        classNames: { col: "mb-3", label: "mb-1" }
      },

      {
        name: "SeqOthersJob.InformOtherJob.CustContract.Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
      {
        name: "SeqOthersJob.InformOtherJob.CustContract.Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
      {
        name: "PM_Per_Year",
        label: "จำนวน PM",
        sublabel: "ครั้ง / ปี",
        classNames: { col: "mb-3", label: "mb-1" },
        findValue: {
          CustContractItems,
          key: "Contract_No",
          value: "PM_Per_Year"
        }
      }
    ],
    Checkbox: [
      {
        name: "JobList1",
        label: "สำรวจหน้างาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: { label: 3 }
      },
      {
        name: "JobList2",
        label: "งานรื้อถอน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: { label: 3 }
      },
      {
        name: "JobList3",
        label: "ติดตั้ง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: { label: 3 }
      },
      {
        name: "JobList4",
        label: "เทสระบบ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: { label: 3 }
      },
      {
        name: "JobList5",
        label: "Training/ส่งมอบ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: { label: 3 }
      },
      {
        name: "JobList6",
        label: "เก็บน้ำ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: { label: 3 }
      }
    ],
    Inform4: [
      {
        name: "Ref_Doc_No",
        label: "หมายเลขอ้างอิง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "datetime",
        label: "วันที่ปิดงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "no",
        label: "หมายเลขงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "time",
        label: "เวลาปิดงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      }
    ],
    note: [
      {
        name: "Note_1",
        label: "",
        classNames: { col: "mt-1 mb-3", label: "mb-1" },
        size: 12
      },
      {
        name: "Note_2",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      },
      {
        name: "Note_3",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      }
    ],
    other: [
      { name: "Printed_By", label: "พิมพ์โดย" },
      { name: "Printed_Date_Time", label: "วัน/เวลามี่พิมพ์" },
      { name: "Approver", label: "ผู้อนุมัติ" }
    ]
  };
  const columns = {
    Report_repair: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "110px" },
      {
        name: "รหัสสินค้า",
        selector: (row) => row?.Item?.Item_Code,
        grow: 2
      },
      {
        name: "รหัสทรัพย์สิน",
        selector: (row) => row?.Item?.Report_repair,
        grow: 2
      },
      {
        name: "รายละเอียดสินค้า",
        selector: (row) => row?.Item?.Item_Name_TH,
        grow: 4,
        wrap: true
      },
      { name: "จำนวน", selector: (row) => row?.Report_repair },
      { name: "หน่วย", selector: (row) => row?.Item?.Unit },
      {
        name: "สถานะทรัพย์สิน",
        selector: (row) => row?.Report_repair,
        grow: 2
      }
    ],
    Standard: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "110px" },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row?.Item?.Standard,
        grow: 3
      },
      { name: "Priority", selector: (row) => row?.Item?.Standard },
      {
        name: "เหตุผลที่ข้ามขั้นตอน",
        selector: (row) => row?.Item?.Standard,
        minWidth: "300px"
      },
      {
        name: "วันที่ปฏิบัติงาน",
        selector: (row) => row?.Standard,
        grow: 2
      },
      { name: "ถ่ายรูป", selector: (row) => row?.Standard },
      { name: "รูปภาพ", selector: (row) => row?.Standard },
      { name: "หมายเหตุ", selector: (row) => row?.Standard }
    ],
    Checklist1: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "110px" },
      {
        name: "รหัสอุปกรณ์/อะไหล่",
        selector: (row) => row?.Item?.Checklist,
        grow: 3
      },
      { name: "Model Number", selector: (row) => row?.Item?.Checklist },
      { name: "Barcode", selector: (row) => row?.Item?.Checklist },
      { name: "สถานะชุดกรอง", selector: (row) => row?.Checklist },
      { name: "วันที่เปลี่ยนล่าสุด", selector: (row) => row?.Checklist },
      { name: "วันหมดอายุ", selector: (row) => row?.Checklist }
    ],
    Checklist2: [
      { name: "Priority", selector: (row) => row?.Checklist },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row?.Item?.Checklist },
      { name: "วันที่เปลี่ยน", selector: (row) => row?.Checklist },
      { name: "วันที่เปลี่ยนครั้งถัดไป", selector: (row) => row?.Checklist },
      { name: "ถึงวันที่", selector: (row) => row?.Checklist },
      { name: "สถานะชุดกรอง", selector: (row) => row?.Checklist }
    ],
    Record1: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "110px" },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row?.Item?.Record,
        grow: 3
      },
      { name: "ค่า", selector: (row) => row?.Item?.Record },
      { name: "หน่วย", selector: (row) => row?.Item?.Record },
      { name: "Priority", selector: (row) => row?.Record },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row?.Record, grow: 3 }
    ],
    Record2: [
      { name: "วันที่ปฏิบัติงาน", selector: (row) => row?.Record, grow: 2 },
      { name: "ถ่ายรูป", selector: (row) => row?.Record },
      { name: "รูปภาพ", selector: (row) => row?.Item?.Record },
      { name: "หมายเหตุ", selector: (row) => row?.Record }
    ],
    Special: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "110px" },
      {
        name: "รายละเอียดข้อกำหนด",
        selector: (row) => row?.Item?.Special,
        grow: 2
      },
      { name: "ข้อกำหนดเพิ่มเติมอื่นๆ", selector: (row) => row?.Item?.Special },
      { name: "PM/ครั้งที่", selector: (row) => row?.Item?.Special }
    ],
    Technician: []
  };

  const showData = (field) => {
    return field.map(
      (
        { name, label, size, classNames, format, plusString, findValue, style },
        idx
      ) => {
        let joinData = formatSplitKey(name, ".", Seq);
        const result =
          (name === "Seq_Oth_No" && Seq?.[name]) ||
          (plusString && plusString) ||
          (findValue && CustContractItems?.[findValue?.value]) ||
          (format && format(joinData)) ||
          joinData;

        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={classNames?.col}
          >
            {name && (
              <FloatingControlComponent
                readOnly
                type="text"
                name={name}
                label={label}
                className={classNames}
                style={style}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  useEffect(() => {
    // console.log(state, Seq)
    getServiceRequest({
      showAlert,
      setLoading,
      // serviceRequest: CustContractItemsService.getCustContractItems(
      //   `?keyword=${Seq?.SeqOthersJob?.InformOtherJob?.Contract_No}`
      // ),
      serviceRequest: CustContractItemsService.getCustContractItems(`?keyword=${state?.Contract_No}`),
      callback: ({ items }) => {
        setCustContractItems(
          findItemInArray(
            items,
            "Contract_No",
            state?.Contract_No || Seq?.SeqOthersJob?.InformOtherJob?.Contract_No
          )
        );
      }
    });
  }, []);

  return (
    <div className="position-relative">
      <PrintButton
        componentRef={canvasRef}
        button={{ style: { zIndex: 10, top: "25px", right: "25px" } }}
      />

      <Card.Body ref={canvasRef} className="mt-1">
        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-5",
            element: (
              <>
                <Col
                  sm={9}
                  className="ReportHead mb-3 d-flex align-items-center"
                >
                  <ReportHeadComponent formName="SERVICE REQUEST FORM" />
                </Col>

                <Col as={Row} className="mb-3">
                  {showData(inputField.headerReport)}
                </Col>

                {showData(inputField.Inform)}
              </>
            )
          }}
        />

        <CardDisplayComponent
          header={{
            title: { text: "รายละเอียดงานที่แจ้ง", className: "text-center" }
          }}
          body={{
            as: Row,
            className: "mx-5",
            element: showData(inputField.Inform2)
          }}
        />

        <CardDisplayComponent
          header={{
            title: { text: "รายละเอียดอุปกรณ์ที่แจ้งซ่อม", className: "mx-5" }
          }}
          body={{
            className: "mx-5",
            element: (
              <Table
                data={Seq?.SeqOthersJob?.InformOtherJob?.ItemOther
                  || Seq?.SeqInstalljob?.InformInstallJobs?.ItemOther
                  || Seq?.RepairJobs?.informRepairJob?.ItemOther
                  || []
                }
                column={columns?.Report_repair}
              />
            )
          }}
        />

        <CardDisplayComponent
          header={{
            title: { text: "ขั้นตอนปฏิบัติงานตามมาตรฐาน", className: "mx-5" }
          }}
          body={{
            className: "mx-5",
            element: (
              <Table data={Seq?.Standard || []} column={columns?.Standard} />
            )
          }}
        />

        <CardDisplayComponent
          header={{
            title: {
              text: "รายการตรวจสอบ / เปลี่ยน Sparepart",
              className: "mx-5"
            }
          }}
          body={{
            className: "mx-5",
            element: (Seq?.Checklist || [null])?.map((item, idx) => (
              <div key={idx} className="border-5 border-bottom">
                <Table data={item ? [item] : []} column={columns?.Checklist1} />
                <Table data={item ? [item] : []} column={columns?.Checklist2} />
              </div>
            ))
          }}
        />

        <CardDisplayComponent
          header={{ title: { text: "รายการบันทึกข้อมูล", className: "mx-5" } }}
          body={{
            className: "mx-5",
            element: (Seq?.Record || [null])?.map((item, idx) => (
              <div key={idx} className="border-5 border-bottom">
                <Table data={item ? [item] : []} column={columns?.Record1} />
                <Table data={item ? [item] : []} column={columns?.Record2} />
              </div>
            ))
          }}
        />

        <CardDisplayComponent
          header={{
            title: {
              text: "ข้อกำหนดเพิ่มเติม (คำสั่งพิเศษ)",
              className: "mx-5"
            }
          }}
          body={{
            className: "mx-5",
            element: (
              <Table data={Seq?.Special || []} column={columns?.Special} />
            )
          }}
        />

        <CardDisplayComponent
          header={{
            title: { text: "Preventive Maintenance", className: "mx-5" }
          }}
          body={{
            className: "mx-5",
            element: (
              <>
                <Row>
                  {inputField.PreventiveRadio.map(({ name, label }, idx) => (
                    <Col key={idx} sm={1} className="mb-3 w-auto">
                      <FormCheckComponent
                        inline
                        readOnly
                        name="list"
                        type="radio"
                        label={label}
                        className={{
                          check: "py-3",
                          input: "me-2",
                          label: "ms-1"
                        }}
                        checked={Seq?.SeqOthersJob?.InformOtherJob?.[name] === label}
                      />
                    </Col>
                  ))}
                </Row>
                <Row>{showData(inputField.PreventiveInput)}</Row>
              </>
            )
          }}
        />

        <CardDisplayComponent
          header={{ title: { text: "รายละเอียดการทำงาน", className: "mx-5" } }}
          body={{
            as: Row,
            className: "mx-5",
            element: inputField.Checkbox.map((item, idx) => (
              <Col key={idx} sm={1} className="mb-3 w-auto ">
                <Form.Check className="py-2 p-5 fs-4" key={idx}>
                  <Form.Check.Input
                    type="checkbox"
                    name="list"
                    checked={Seq?.SeqOthersJob?.InformOtherJob?.[item.name] === item.label}
                    readOnly
                  />
                  {item.label}
                </Form.Check>
              </Col>
            ))
          }}
        />

        <Row>
          <Col sm={6}>
            <CardDisplayComponent
              header={{
                title: { text: "สำหรับการแจ้งปิดงาน", className: "mx-5" }
              }}
              body={{
                as: Row,
                className: "ms-5",
                element: (
                  <>
                    {showData(inputField.Inform4)}
                    <Card.Title className="mb-3 fs-2">หมายเหตุ</Card.Title>
                    {showData(inputField.note)}
                  </>
                )
              }}
            />
          </Col>
          <Col sm={6}>
            <CardDisplayComponent
              header={{
                title: { text: "รายชื่อช่างทำงาน", className: "mx-5" }
              }}
              body={{
                className: "mb-3 me-5",
                element: [1, 2, 3, 4, 5, 6, 7].map((item) => (
                  <Row
                    key={item}
                    className={`py-3 fs-4 border-top ${item === 7 ? "border-bottom mb-1" : ""
                      }`}
                  >
                    {item}
                  </Row>
                ))
              }}
            />
          </Col>
        </Row>

        <CardDisplayComponent
          body={{
            as: Row,
            className: "justify-content-center",
            element: showData(inputField.other)
          }}
        />
      </Card.Body>

      <CardDisplayComponent
        body={{
          element: (
            <PaginationComponent
              data={state?.Work || []}
              currentPage={currentPage}
              itemsPerPage={1}
              onPageChange={(newPage) => setCurrentPage(newPage)}
            />
          )
        }}
      />

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/service_work/planning", {
                  state: { name: "EventplaningDetail" }
                })
              }
            >
              ย้อนกลับ
            </Button>
          )
        }}
      />
    </div>
  );
};

PreviewOther.propTypes = {
  Id: PropTypes.number.isRequired
};

export default PreviewOther;
